/**
 * Relative time formatting for comment timestamps.
 * Accepts a Firestore Timestamp, a Date, or null. A null value means the
 * local snapshot has not received the server timestamp yet ("just now").
 */

export const formatRelativeTime = (value) => {
  if (!value) return 'just now';
  const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
  if (isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();
  if (diffMs < 60 * 1000) return 'just now';

  const minutes = Math.floor(diffMs / (60 * 1000));
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.floor(hours / 24);
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days} days ago`;

  return date.toLocaleDateString();
};
